import navBarHomepage from '../modules/navbar-homepage';
import videoLanding from '../modules/video-landing';

let videoController = () => {
    navBarHomepage.on();
    videoLanding();
};

export default videoController;
